import Popup from "../Popup/Popup";
import { Trans, useTranslation } from "react-i18next";

type OnboardingPopupProps = {
    titleKey: string;
    contentKey: string;
    display: boolean;
    onClose: () => void;
    onSubmit: () => void;
    onPopup?: boolean;
    values?: Record<string, string>;
};

const defaultValues = {
    email: "catermat@catermat.com",
    phone: "(+420) 222 510 446",
};

const OnboardingPopup = ({
    titleKey,
    contentKey,
    display,
    onClose,
    onSubmit,
    onPopup,
    values,
}: OnboardingPopupProps) => {
    const { t } = useTranslation();

    return (
        <Popup
            title={t(titleKey)}
            backBtnText={t("onboarding.popup.back")}
            submitBtnText={t("onboarding.popup.proceed")}
            onClose={onClose}
            onSubmit={onSubmit}
            textMode={true}
            display={display}
            onPopup={onPopup}
        >
            <Trans
                i18nKey={contentKey}
                components={{
                    6: <p />,
                    1: <br />,
                    2: <p />,
                    3: <span />,
                    4: <p />,
                    5: <span />,
                }}
                values={values ?? defaultValues}
            />
        </Popup>
    );
};

export default OnboardingPopup;
